export const kholasehVaziatsReducer = (state = [], action) => {
    switch (action.type) {
        case "KHLSH":
            return [...action.payload];
        default:
            return state;
    }
};
